import { Spacing } from '../../design-system/spacing';
import { styled } from '../../utils/styled';
import { FormHelperText } from '../FormHelperText';
import { Typography } from '../Typography';

const StyledFormHelperText = styled(FormHelperText)`
  display: block;
  height: ${({ theme }) => theme.spacing(Spacing.Medium)};
  margin: ${({ theme }) => theme.spacing(Spacing.None)};
`;
interface FormErrorProps {
  readonly errorText?: string;
  readonly showError?: boolean;
}

export function FormError({ errorText, showError }: FormErrorProps) {
  return (
    <StyledFormHelperText component="span">
      <Typography color="error" variant="caption">
        {showError ? errorText : ''}
      </Typography>
    </StyledFormHelperText>
  );
}
